import Decimal from 'decimal.js';
import { useModelGroupsQuery } from '../api/useModelGroupsQuery';

export const useDefaultAssetAllocation = () => {
  const { data } = useModelGroupsQuery();

  if (!data) {
    return null;
  }

  const {
    options: { defaultAssetAllocation },
  } = data;

  return defaultAssetAllocation.map(asset => ({
    ...asset,
    y: asset.y ? new Decimal(asset.y).times(100).toNumber() : 0,
  }));
};
